/*
 *  Manipulations to affect markup from CMS fields
 */

const initialize = () => {
    // .button in .sidebar-box should convert to a compact underline button
    $('.sidebar-box .button')
        .addClass(['button-underline', 'button-compact'])
        .wrapInner('<span></span>');
};

export default {
    initialize,
};

